import * as React from "react"
import * as styles from './contact-form.module.scss';
import ReCAPTCHA from "react-google-recaptcha";
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faArrowRightLong } from '@fortawesome/free-solid-svg-icons'
import { Link } from "gatsby";
const axios = require('axios');

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

    document.getElementById("submit_button").style.display = "none";
    var spinner = document.getElementById("spinner_container");
    spinner.classList.remove(styles.hidden);
    spinner.setAttribute("aria-hidden", "false");

    var errorMessage = document.getElementById("error_message_container");
    errorMessage.classList.add(styles.hidden);
    errorMessage.setAttribute("aria-hidden", "true");

    const formData = new FormData(event.target);
    formData.append('action','sign-up-form');

    axios.post(
      process.env.GATSBY_API_ENDPOINT,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      },
    )
    .then( response => {
      // console.log(response);
      var form = document.getElementById("submission_form");
      form.classList.add(styles.hidden)

      var message = document.getElementById("success_message");
      message.classList.remove(styles.hidden);
      message.setAttribute("aria-hidden", "false");

    })
    .catch(function (error) {

      // console.log(error);
      // var errorMessage = document.getElementById("error_message_container");
      errorMessage.classList.remove(styles.hidden);
      errorMessage.setAttribute("aria-hidden", "false");
      errorMessage.innerHTML = 'ERROR: <code>' + error.response.data.message + '</code>';
      // errorMessage.innerHTML = 'ERROR: <code>' + error.code + ': ' + error.message + '</code>';

    
      document.getElementById("submit_button").style.display = "inline-block";
      var spinner = document.getElementById("spinner_container");
      spinner.classList.add(styles.hidden);
      spinner.setAttribute("aria-hidden", "true");

    });

  }

  render() {
    return (
      <div>
        <div className={`${styles.message} ${styles.successMessage} ${styles.hidden}`} aria-hidden="true" id="success_message">
        Thank you, your submission has been sent successfully.
        </div>

        <form method="POST" onSubmit={this.handleSubmit} id="submission_form">
          <div className={`row ${styles.formRow}`}>
            <div className={`col-6 ${styles.formCol}`}>
              <label htmlFor="fname">First Name<span className={styles.requiredField}>*</span></label>
              <input type="text" id="fname" name="fname" required />
            </div>
            <div className={`col-6 ${styles.formCol}`}>
              <label htmlFor="lname">Last Name<span className={styles.requiredField}>*</span></label>
              <input type="text" id="lname" name="lname" required />
            </div>
          </div>
  
          <div className={`row ${styles.formRow}`}>
            <div className={`col-12 ${styles.formCol}`}>
              <label htmlFor="email">Email Address<span className={styles.requiredField}>*</span></label>
              <input type="email" id="email" name="email" required />
            </div>
          </div>
  
          <div className={`row ${styles.formRow}`}>
            <div className={`col-6 ${styles.formCol}`}>
              <label htmlFor="phone">Phone<span className={styles.requiredField}>*</span></label>
              <InputMask mask="999-999-9999" id="phone" name="phone" required />
              <span className={styles.fieldDesc}>Use format: 714-123-4567</span>
            </div>
            <div className={`col-6 ${styles.formCol}`}>
              <label htmlFor="zip">Zip Code<span className={styles.requiredField}>*</span></label>
              <InputMask mask="99999" id="zip" name="zip" required />
              <span className={styles.fieldDesc}>Enter your 5 digit zipcode.</span>
            </div>
          </div>
          <div className={`row ${styles.formRow}`}>
            <div className={`col-12 ${styles.formCol}`}>
              <label htmlFor="email">Message<span className={styles.requiredField}>*</span></label>
              <textarea id="message" name="message" required rows="5"></textarea>
            </div>
          </div>
          <div className={`row ${styles.formRow}`}>
            <div className={`col-12 ${styles.formCol}`}>

            <p className={styles.labelStyling}>I would like to help with: (check all that apply)</p>

            <div className={styles.checkBoxGroup}>
              <input type="checkbox" id="help0" name="help[]" value="Post a yard sign" className="" />
              <label htmlFor="help0" >Post a yard sign</label>
            </div>
  
            <div className={styles.checkBoxGroup}>
              <input type="checkbox" id="help1" name="help[]" value="Make phone calls" />
              <label htmlFor="help1" >Make phone calls</label>
            </div>
  
            <div className={styles.checkBoxGroup}>
              <input type="checkbox" id="help3" name="help[]" value="Send text messages" />
              <label htmlFor="help3" >Send text messages</label>
            </div>
            
            <div className={styles.checkBoxGroup}>
              <input type="checkbox" id="help2" name="help[]" value="Knock on doors" />
              <label htmlFor="help2" >Knock on doors</label>
            </div>
  
            <div className={styles.checkBoxGroup}>
              <input type="checkbox" id="help4" name="help[]" value="Host a meet and greet or event" />
              <label htmlFor="help4" >Host a meet and greet or event</label>
            </div>

            </div>
          </div>
          <div className={`row ${styles.formRow}`}>

            <div className={`col-12 ${styles.formCol}`}>
              <ReCAPTCHA
                style={{overflow: 'hidden'}}
                sitekey={process.env.GATSBY_ReCAPTCHA_SITE_KEY}
              />
            </div>

          </div>
          <div className={`row ${styles.formRow}`}>

            <div className={`col-12 ${styles.formCol}`}>
              {/* <input id="submit_button" type="submit" value="Submit" className={`button primary ${styles.submitButton}`} /> */}
              <button id="submit_button" type="submit" className={`button primary ${styles.submitButton}`}>Sign Up <FontAwesomeIcon icon={faArrowRightLong} size="xs" /></button>
            </div>

          </div>
          
          <div aria-hidden="true" id="spinner_container" className={`${styles.hidden} ${styles.spinnerContainer}`}>
            <div>
              <FontAwesomeIcon icon={faSpinner} spin />
              <p>Processing...</p>
            </div>
          </div>
  
        </form>
        <div className={`${styles.hidden} ${styles.message} ${styles.errorMessageContainer}`} aria-hidden="true" id="error_message_container">
        Sorry, something went wrong. Please try again.
        </div>
      </div>
    );
  }
}